import { CommonIP } from '@model/ftf-api.model';
import { createReducer, on } from '@ngrx/store';

import * as FavoritesActions from '../actions/favorites.actions';

export interface FavoritesState {
  favorites: CommonIP[];
  isLoaded: boolean;
  error: string | null;
}

export const initialState: FavoritesState = {
  favorites: [],
  isLoaded: false,
  error: null,
};

export const favoritesReducer = createReducer(
  initialState,
  on(FavoritesActions.loadFavoritesSuccess, (state, { favorites }) => ({
    ...state,
    favorites,
    isLoaded: true,
    error: null,
  })),
  on(FavoritesActions.loadFavoritesFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(FavoritesActions.addFavoriteItemSuccess, (state, { favorites }) => ({
    ...state,
    favorites: favorites,
    isLoaded: true,
    error: null,
  })),
  on(FavoritesActions.addFavoriteItemFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(FavoritesActions.removeFavoriteItemSuccess, (state, { favorites }) => ({
    ...state,
    favorites: favorites,
    isLoaded: true,
    error: null,
  })),
  on(FavoritesActions.removeFavoriteItemFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(FavoritesActions.resetFavoritesState, () => initialState)
);
